import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const DashboardPrintlistSlice = createSlice({
  name: "DashboardPrintlistSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    DashboardPrintlist: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successDashboardPrintlist: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDashboardPrintlist: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDashboardPrintlist: (state) => {
      state.data = {};
    },
  },
});

export const {
  DashboardPrintlist,
  successDashboardPrintlist,
  failureDashboardPrintlist,
  clearDashboardPrintlist,
} = DashboardPrintlistSlice.actions;

export default DashboardPrintlistSlice.reducer;
